export default __webpack_public_path__ + "static/media/Moniter.04a88878.png";